import React from 'react';
import Nav from 'react-bootstrap/Nav';
import styled from 'styled-components';
import logo from '../assets/images/logo-white.svg';
import Container from 'react-bootstrap/Container';
import { breakpoints } from '../stylesheets/variables';

const Footer = (props) => {
  const { isAuth } = props;

  return <StyledFooter>
    <Container fluid="lg">
      <div className="footer-wrap">
        <div className="footer-links">
          <img src={logo} alt="Matsutek" className='logo' />
          <ul>
            <li><a href="https://www.matsutek.com/pages/terms">使用條款</a></li>
            <li><a href="https://www.matsutek.com/pages/privacy">隱私權條款</a></li>
            <li>2025 © <a href="https://www.matsutek.com/">松騰實業</a></li>
          </ul>
        </div>
        <Nav className='footer-navi'>
          <Nav.Link href="/announcement">
            公告訊息
          </Nav.Link>
          {isAuth && <Nav.Link href="/battery">
            我的電池
          </Nav.Link>}
          <Nav.Link href="/activity">最新活動</Nav.Link>
        </Nav>
      </div>
    </Container>
  </StyledFooter>;
};
const StyledFooter = styled.footer`
  background-color: #000;
  color: #fff;
  padding: 25px 0;
  font-size: 0.9rem;
  position: relative;
  z-index: 1;
  ${breakpoints.down_md} {
    padding: 15px 0;
  }
  .footer-wrap{ 
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${breakpoints.down_md} {
      display: block;
    }
  }
  .footer-links{
    display: flex;
    align-items: center;
    ${breakpoints.down_md} {
      justify-content: space-between;
    }
    ${breakpoints.down_sm} {
      flex-direction: column;
    }
    .logo{
      width: 160px;
      ${breakpoints.down_md} {
        width: 100px;
      }
    }
    ul{
      display: flex;
      justify-content: center;
      list-style: none;
      padding: 0;
      margin: 0 0 0 3rem;
      ${breakpoints.down_sm} {
        margin: 0.75rem 0 0;
      }
      li{
        &:not(:last-child){
          &:after{
            content: '|';
            margin: 0 1rem;
            ${breakpoints.down_sm} {
              margin: 0 .5rem;
            }
          }
        }
        a{
          color: #fff;
          text-decoration: none;
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
  }
  .footer-navi{
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    ${breakpoints.down_md} {
      display: none;
    }
    a{
      color: #fff;
      font-size: 0.9rem;
      padding: 0 1rem;
      text-decoration: none;
      &:last-child{
        padding-right: 0;
      }
      &:hover{
        text-decoration: underline;
      }
    }
  }
`;
export default Footer;
